import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface MaintenanceSuggestion {
  id: number;
  title: string;
  description?: string;
  urgency?: string;
  address_id?: number;
  address_name?: string;
  status?: string;
  issue_report_type?: {
    id: number;
    name: string;
  };
  photos?: { photo_url: string }[];
  room_object?: {
    id: number;
    name: string;
    model?: {
      category?: {
        default_icon_url?: string;
      };
    };
  };
  due_date?: string;
  created_at?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceSuggestionsService {

  constructor(private http: HttpClient) {}

  async getMaintenanceSuggestions(): Promise<MaintenanceSuggestion[]> {
    return firstValueFrom(
      this.http.get<MaintenanceSuggestion[]>(`${environment.api_url}api/v1/customer/maintenance-suggestions`)
    );
  }

  async acceptSuggestion(suggestionId: number, acceptAs: 'recurring' | 'one_time'): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.api_url}api/v1/customer/maintenance-suggestions/${suggestionId}/accept`, {
        accept_as: acceptAs
      })
    );
  }

  async rejectSuggestion(suggestionId: number): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.api_url}api/v1/customer/maintenance-suggestions/${suggestionId}/reject`, {})
    );
  }
}
